import React from 'react';
import PropTypes from 'prop-types';


class AuditDetailsAccount extends React.Component {
    renderEventDetailsTableRow(audits, toExclude, levelKey = [], styleClassName = 'none') {
        const keyArr = [...levelKey];

        return Object.keys(audits).map((key) => {
            if (toExclude.includes(key) === false) {

                if (audits[key] !== null && audits[key].constructor === Object) {
                    keyArr.push(key);
                    return this.renderEventDetailsTableRow(audits[key], toExclude, keyArr, styleClassName);
                }

                const renderKey = keyArr.join('.');
                if (audits[key] !== null && audits[key].constructor === Array) {
                    return audits[key].map((item) => {
                        if (item.constructor === Object) {
                            return (
                                <tr className={styleClassName} key={`${key}-${item.name}`}>
                                    <td>{ renderKey.charAt(0).toUpperCase() + renderKey.slice(1) + '.' + key + '.' + item.name }</td>
                                    <td>{JSON.stringify(item.value)}</td>
                                </tr>
                            );
                        } else {
                            return (
                                <tr className={styleClassName} key={`${key}-${renderKey.slice(1)}`}>
                                    <td>{ renderKey.charAt(0).toUpperCase() + renderKey.slice(1) + '.' + key }</td>
                                    <td>{audits[key].join(', ')}</td>
                                </tr>
                            );
                        }
                    });
                }

                return (
                    <tr className={styleClassName} key={`${key}-${renderKey.slice(1)}`}>
                        {keyArr.length > 0 ?
                            <td>{ renderKey.charAt(0).toUpperCase() + renderKey.slice(1) + '.' + key }</td> :
                            <td>{key.charAt(0).toUpperCase() + key.slice(1)}</td>}
                        <td>{(typeof (audits[key]) === 'string' || audits[key] === null) ? audits[key] : JSON.stringify(audits[key])}</td>
                    </tr>
                );
            }
        });
    }

    renderEventDetailsTable() {
        const { audits, id } = this.props;
        const toExclude = ['body'];

        const eventType = id.split('_');
        const eventArr = eventType[eventType.length - 1].split('-');
        for (let i = 0; i < toExclude.length; i++) {
            if (eventArr[0].includes(toExclude[i].slice(0, 5))) {
                toExclude.splice(i, 1);
            }
        }

        return (
            <table>
                <thead>
                    <td>
                        <strong>
                        {eventArr[0].charAt(0).toUpperCase() + eventArr[0].slice(1) + ' ' + eventArr[1].charAt(0).toUpperCase() + eventArr[1].slice(1) }
                        </strong>
                    </td>
                    <td>
                        <strong>
                            Value
                        </strong>
                    </td>
                </thead>
                <tbody>
                    {this.renderEventDetailsTableRow(audits.body, toExclude)}

                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    {this.renderEventDetailsTableRow(audits, toExclude, [], 'technical-details')}
                </tbody>
            </table>
        );
    }

    render() {
        return (
            <div className='audit-details-account'>
                {this.renderEventDetailsTable()}
            </div>
        );
    }
}

export default AuditDetailsAccount;
